import { Pipe, PipeTransform } from "@angular/core";
import { linkifyPlainText } from "../utils/rich-text-content.util";

/**
 * Converts plain text with URLs into HTML with clickable links.
 * Escapes non-URL text to prevent XSS. For rich text HTML, use cRichTextContent instead.
 */
@Pipe({
  name: "cLinkify",
})
export class CLinkifyPipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    return linkifyPlainText(value);
  }
}
